import { motion } from "framer-motion";
import { ClipboardList, PhoneCall, Gift } from "lucide-react";

const steps = [
  { icon: ClipboardList, title: "Completa 2 datos", desc: "Solo tu nombre y teléfono. Sin formularios largos ni compromiso." },
  { icon: PhoneCall, title: "Recibe tu asesoría", desc: "Un especialista te llama, escucha tu situación y te prepara una cotización personalizada gratis." },
  { icon: Gift, title: "Reclama tu bono de $50", desc: "Usa tu código al cotizar tu seguro de auto con nosotros y aplica tu descuento." },
];

export const Steps = () => (
  <section id="como-funciona" className="py-20 lg:py-28 bg-[var(--slate-50)] scroll-mt-20" data-testid="steps-section">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="lg:flex lg:items-end lg:justify-between gap-10">
        <div className="max-w-xl">
          <p className="text-xs font-bold tracking-[0.2em] text-brand-blue uppercase">Cómo funciona</p>
          <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-navy">
            Tres pasos sencillos. Cero complicaciones.
          </h2>
        </div>
        <p className="mt-4 lg:mt-0 text-base md:text-lg text-slate-600 max-w-md">
          Diseñamos el proceso para que en menos de un minuto estés un paso más cerca de proteger a los tuyos.
        </p>
      </div>

      <ol className="mt-14 grid md:grid-cols-3 gap-6 relative">
        <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-px bg-gradient-to-r from-[var(--blue-600)] via-[var(--green-500)] to-[var(--blue-600)] opacity-40" />
        {steps.map(({ icon: Icon, title, desc }, i) => (
          <motion.li
            key={title}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.55, delay: i * 0.15 }}
            className="relative rounded-2xl bg-white border border-slate-200 p-7 card-lift"
            data-testid={`step-card-${i + 1}`}
          >
            <div className="flex items-center justify-between">
              <span className="grid place-items-center h-14 w-14 rounded-2xl gradient-brand text-white shadow-lg">
                <Icon className="h-7 w-7" />
              </span>
              <span className="font-heading text-5xl font-extrabold text-slate-100">0{i + 1}</span>
            </div>
            <h3 className="mt-6 text-xl font-bold text-navy">{title}</h3>
            <p className="mt-2 text-slate-600 leading-relaxed">{desc}</p>
          </motion.li>
        ))}
      </ol>
    </div>
  </section>
);
